const customerFormatArray = [
    {
        back: 'business_name',
        front: 'businessName'
    },
    {
        back: 'alias_name',
        front: 'personName'
    },
    {
        back: 'core_business',
        front: 'coreBusiness'
    },
]

export default customerFormatArray